/* L'Apprêt — pièces marquées (signet, localStorage) */
(function () {
  const KEY = 'la-pieces-marquees';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('la:marques:change'));
  }

  window.laMarques = {
    all: read,
    has: function (handle) { return read().indexOf(handle) !== -1; },
    toggle: function (handle) {
      const list = read();
      const i = list.indexOf(handle);
      if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
      write(list);
    },
    remove: function (handle) {
      write(read().filter(function (h) { return h !== handle; }));
    }
  };

  function refresh() {
    document.querySelectorAll('.la-signet').forEach(function (btn) {
      const active = window.laMarques.has(btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Retirer des pièces marquées' : 'Marquer la pièce');
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.la-signet');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.laMarques.toggle(btn.dataset.handle);
    refresh();
  });

  document.addEventListener('la:marques:change', refresh);

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    const grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(refresh).observe(grid, { childList: true, subtree: true });
    }
  });
})();